import type { CaptionSegment } from "../../lib/fingerspelling";

type CaptionTextProps = { segments: readonly CaptionSegment[] };

/** 説明文を表示する。ふりがながある区切りは <ruby> で表示する */
export const CaptionText = ({ segments }: CaptionTextProps) => (
  <span>
    {segments.map((segment, index) =>
      segment.ruby ? (
        // 区切りは固定の並びで、並べ替えや挿入はしない
        // biome-ignore lint/suspicious/noArrayIndexKey: 静的な並び
        <ruby key={index}>
          {segment.text}
          <rt>{segment.ruby}</rt>
        </ruby>
      ) : (
        // biome-ignore lint/suspicious/noArrayIndexKey: 静的な並び
        <span key={index}>{segment.text}</span>
      ),
    )}
  </span>
);
